/* VAEN PDP v4 · b — proof cards · material layer drawing · sample kit */
(function () {
  if (window.__vnp4b) return; window.__vnp4b = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, a, p) { var e = document.createElementNS(NS, tag); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function inView(node, cb, th) { if (!('IntersectionObserver' in window)) { cb(true); return; } new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, { threshold: th || 0.3 }).observe(node); }
  function onVariant(fn) {
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(fn, 40); });
    document.addEventListener('vnp4:variant', function () { setTimeout(fn, 40); });
  }
  function reveal(root) { $$('.vn-reveal', root).forEach(function (r) { r.classList.add('is-in'); }); }

  /* option values (optionally excluding leg/base options) */
  function options(skipLegs) {
    var out = [];
    $$('variant-selects fieldset').forEach(function (fs) {
      var lg = $('legend', fs), n = ((lg && lg.textContent) || '').toLowerCase();
      var c = $('input[type="radio"]:checked', fs); if (!c) return;
      if (skipLegs && (n.indexOf('leg') > -1 || n.indexOf('base') > -1)) return;
      out.push({ name: n, value: c.value.toLowerCase() });
    });
    $$('variant-selects select').forEach(function (sl) { var n = (sl.name || '').toLowerCase(); if (skipLegs && (n.indexOf('leg') > -1 || n.indexOf('base') > -1)) return; out.push({ name: n, value: (sl.value || '').toLowerCase() }); });
    return out;
  }
  function legValue() { var o = options(false).filter(function (x) { return x.name.indexOf('leg') > -1 || x.name.indexOf('base') > -1; })[0]; return o ? o.value : null; }

  /* finish colours */
  var COLORS = { 'off white': '#E8E3DA', 'ivory': '#E6DCC6', 'sand': '#CDBFA6', 'gray': '#A39F98', 'grey': '#A39F98', 'black': '#2A2826', 'taupe': '#9C8F80', 'beige': '#D7C8AE', 'white matte': '#EFEDE8', 'white': '#EFEDE8', 'terracotta': '#B4643F', 'earth': '#8C6A4E', 'green matte': '#5B6650', 'green': '#55604A', 'brown matte': '#6B4E3B', 'brown': '#6B4E3B',
    'dark oak': '#4B3526', 'white oak': '#CFB48E', 'natural oak': '#BE9668', 'hazelnut oak': '#A27A52', 'hazelnut': '#A27A52', 'oak veneer': '#B48A5E', 'cherry': '#8A4B2E', 'medium oak': '#9A6E45', 'light oak': '#C9A77D', 'medium': '#9A6E45', 'dark': '#4B3526', 'oak': '#B08757', 'natural': '#C6A47A', 'walnut': '#5A3B27', 'ash wood': '#D2BD98', 'ash': '#D2BD98', 'teak': '#8E5E36',
    'travertine': '#D9C9AC', 'daino reale': '#CDBB9C', 'daino': '#CDBB9C', 'marble': '#ECEAE5', 'stainless': '#B9BCBE', 'steel': '#B9BCBE' };
  var CKEYS = Object.keys(COLORS).sort(function (a, b) { return b.length - a.length; });
  function colorOf(v) { if (!v) return null; for (var j = 0; j < CKEYS.length; j++) if (v.indexOf(CKEYS[j]) > -1) return COLORS[CKEYS[j]]; return null; }
  function shade(hex, f) { var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255; function m(c) { return Math.round(f < 0 ? c * (1 + f) : c + (255 - c) * f); } return '#' + ((1 << 24) | (m(r) << 16) | (m(g) << 8) | m(b)).toString(16).slice(1); }
  function lum(hex) { var n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; }

  /* =================== GALLERY v6 + option dots =================== */
  function initGallery() {
    var head = $('.vnp9-head'), wrap = $('.pulse-gallery-wrap');
    if (!head || !wrap || wrap.__v) return; wrap.__v = 1;
    var slides = $$('.product__media-list > li', wrap), n = slides.length;
    var cnt = $('.pulse-counter-current', wrap), next = $('.pulse-lg-btn--next', wrap), prev = $('.pulse-lg-btn--prev', wrap);
    var g = document.createElement('div'); g.className = 'vnp9-gal';
    var thumbs = '', bars = '';
    slides.forEach(function (li, i) {
      var im = $('img', li), src = im ? (im.getAttribute('src') || '') : '';
      src = src.replace(/width=\d+/, 'width=160');
      thumbs += '<button type="button" data-i="' + i + '" aria-label="Image ' + (i + 1) + '">' + (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') + '</button>';
      bars += '<i data-i="' + i + '"></i>';
    });
    var mat = ($('.vnp9-crumb span', head) || {}).textContent || '';
    var fit = document.querySelector('[data-pdp-anchor][data-label="Dimensions"]');
    g.innerHTML = '<span class="vnp9-gal__tag"><i></i><span data-t>' + mat + '</span></span>' +
      (n > 1 ? '<span class="vnp9-gal__count"><b data-c>01</b> <span>/ ' + ('0' + n).slice(-2) + '</span></span>' : '') +
      (n > 1 && n <= 9 ? '<div class="vnp9-gal__thumbs">' + thumbs + '</div>' : '') +
      (n > 1 ? '<div class="vnp9-gal__bar">' + bars + '</div>' : '') +
      '<div class="vnp9-gal__acts">' + (fit ? '<a href="#" data-fit><svg viewBox="0 0 16 16"><path d="M2 6V2h4M14 6V2h-4M2 10v4h4M14 10v4h-4"/></svg>Check the fit</a>' : '') +
      '<button type="button" data-zoom><svg viewBox="0 0 16 16"><circle cx="7" cy="7" r="4.5"/><path d="m10.5 10.5 3.5 3.5M7 5v4M5 7h4"/></svg>Zoom</button></div>';
    var tpl = $('template[data-vnp9-seal]');
    if (tpl) { var sd = document.createElement('div'); sd.className = 'vnp9-gal__seal'; sd.appendChild(tpl.content.cloneNode(true)); g.appendChild(sd); }
    wrap.appendChild(g);
    function cur() { var v = cnt ? parseInt(cnt.textContent, 10) : 1; return (isNaN(v) ? 1 : v) - 1; }
    function upd() {
      var c = cur();
      $$('.vnp9-gal__thumbs button', g).forEach(function (b, i) { b.classList.toggle('is-on', i === c); });
      $$('.vnp9-gal__bar i', g).forEach(function (b, i) { b.classList.toggle('is-on', i === c); b.classList.toggle('is-past', i < c); });
      var cc = $('[data-c]', g); if (cc) cc.textContent = ('0' + (c + 1)).slice(-2);
    }
    function goTo(i) { var d = i - cur(), b = d > 0 ? next : prev; for (var k = 0; k < Math.abs(d); k++) if (b) b.click(); setTimeout(upd, 60); }
    $$('.vnp9-gal__thumbs button, .vnp9-gal__bar i', g).forEach(function (b) { b.addEventListener('click', function () { goTo(parseInt(b.dataset.i, 10)); }); });
    var z = $('[data-zoom]', g); if (z) z.addEventListener('click', function () {
      var li = slides[cur()], op = li && $('modal-opener button, .product__media-toggle, img', li);
      var zt = $('.pulse-zoom-trigger', wrap); if (zt) zt.click(); else if (op) op.click();
    });
    var f = $('[data-fit]', g); if (f) f.addEventListener('click', function (e) { e.preventDefault(); var y = fit.getBoundingClientRect().top + scrollY - 120; scrollTo({ top: y, behavior: 'smooth' }); });
    if (cnt) new MutationObserver(upd).observe(cnt, { childList: true, characterData: true, subtree: true });
    function tag() {
      var fn = finish(), t = $('[data-t]', g), dot = $('.vnp9-gal__tag i', g);
      if (t) t.textContent = mat + (fn ? ' · ' + fn.name : '');
      if (dot) { if (fn) { dot.style.background = fn.hex; dot.style.display = ''; } else dot.style.display = 'none'; }
    }
    onVariant(function () { tag(); setTimeout(upd, 120); }); tag(); upd();
  }
  function optionDots() {
    if (!$('.vnp9-head')) return;
    function run() {
      $$('.vaen-variant-row').forEach(function (r) {
        var k = (r.getAttribute('data-vaen-option-kind') || '') + ' ' + (($('.vaen-variant-row__title', r) || {}).textContent || '').toLowerCase();
        if (!/colou?r|finish|leg|top|wood|stain/.test(k) || /size/.test(k)) return;
        var sel = $('.vnp4-sel', r); if (!sel) return;
        var c = colorOf(sel.textContent.trim().toLowerCase()), d = $('.vnp9-dot', sel);
        if (!c) { if (d) d.remove(); return; }
        if (!d) { d = document.createElement('i'); d.className = 'vnp9-dot'; sel.insertBefore(d, sel.firstChild); }
        d.style.background = c;
      });
    }
    run(); onVariant(function () { setTimeout(run, 60); });
    $$('.vnp4-sel').forEach(function (s) { new MutationObserver(function () { if (!$('.vnp9-dot', s)) setTimeout(run, 0); }).observe(s, { childList: true }); });
  }

  /* =================== TRADE v6 =================== */
  function initTrade(root) {
    var ps = $$('.vnp10-p', root);
    function on(p) { ps.forEach(function (x) { x.classList.toggle('is-on', x === p); }); }
    ps.forEach(function (p) { p.addEventListener('mouseenter', function () { if (matchMedia('(min-width:750px)').matches) on(p); }); p.addEventListener('focus', function () { on(p); }); });
  }

  /* =================== FAQ =================== */
  function initFaq(root) {
    var qs = $$('.vnp8-q', root), chips = $$('[data-vnp8-t]', root), inp = $('[data-vnp8-q]', root), n = $('[data-vnp8-n]', root), empty = $('[data-vnp8-empty]', root), topic = 'all';
    // mobile: atelier card moves under the list
    var card = $('.vnp8-card', root), list = $('[data-vnp8-list]', root);
    if (card && list) { var mc = card.cloneNode(true); mc.classList.add('is-m'); mc.classList.add('is-in'); list.parentNode.appendChild(mc); }
    qs.forEach(function (q) {
      var t = $('.vnp8-q__t', q), a = $('.vnp8-q__in', q); q.__t = t.textContent.replace(/&/g, '&amp;').replace(/</g, '&lt;'); q.__a = a.innerHTML; q.__s = (t.textContent + ' ' + a.textContent).toLowerCase();
      $('.vnp8-q__h', q).addEventListener('click', function () { var o = !q.classList.contains('is-open'); q.classList.toggle('is-open', o); this.setAttribute('aria-expanded', o); });
    });
    function esc(x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function apply() {
      var term = (inp && inp.value || '').trim().toLowerCase(), shown = 0;
      qs.forEach(function (q) {
        var ok = (topic === 'all' || q.dataset.t === topic) && (!term || q.__s.indexOf(term) > -1);
        q.hidden = !ok; if (ok) shown++;
        var t = $('.vnp8-q__t', q);
        t.innerHTML = term ? q.__t.replace(new RegExp('(' + esc(term) + ')', 'ig'), '<mark>$1</mark>') : q.__t;
        if (term && ok && !q.classList.contains('is-open') && shown === 1) { q.classList.add('is-open'); $('.vnp8-q__h', q).setAttribute('aria-expanded', true); }
      });
      if (empty) empty.hidden = shown > 0;
      if (n) n.textContent = term || topic !== 'all' ? (shown + ' / ' + qs.length) : (qs.length + ' Q');
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { topic = c.dataset.vnp8T; chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); }); apply(); }); });
    if (inp) inp.addEventListener('input', apply);
    apply();
  }

  /* =================== MORE OF TYPE =================== */
  function initMore(root) {
    var rail = $('[data-vnp7-rail]', root), bar = $('[data-vnp7-bar]', root), cnt = $('[data-vnp7-count]', root);
    var prev = $('[data-vnp7-prev]', root), next = $('[data-vnp7-next]', root);
    if (!rail) return;
    var cards = $$('.vnp7-card', rail);
    cards.forEach(function (c) {
      var vals = (c.dataset.sw || '').split('|').filter(Boolean), box = $('[data-dots]', c), h = '', seen = {}, k = 0;
      vals.forEach(function (v) { var col = colorOf(v.toLowerCase()); if (col && !seen[col] && k < 5) { seen[col] = 1; k++; h += '<i style="background:' + col + '" title="' + v.replace(/"/g, '') + '"></i>'; } });
      var more = vals.length - k; if (k && more > 0) h += '<b>+' + more + '</b>';
      if (box) box.innerHTML = h;
    });
    function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 16) : rail.clientWidth; }
    function upd() {
      var max = rail.scrollWidth - rail.clientWidth, x = rail.scrollLeft, w = rail.clientWidth / rail.scrollWidth;
      bar.style.width = (w * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (x / max) * ((1 / w) - 1) * 100 : 0) + '%)';
      var i = Math.min(cards.length, Math.round(x / step()) + 1);
      if (max - x < 4) i = cards.length - Math.max(0, Math.round(rail.clientWidth / step()) - 1);
      cnt.textContent = ('0' + Math.max(1, i)).slice(-2) + ' / ' + ('0' + cards.length).slice(-2);
      prev.disabled = x < 4; next.disabled = max - x < 4;
      root.classList.toggle('is-static', max < 4);
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  /* =================== PROOF STAGE (story) =================== */
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function addBD(d, n) { var x = new Date(d); var k = 0; while (k < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) k++; } return x; }
  function md(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }
  function rng(a, b) { return a.getMonth() === b.getMonth() ? MON[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() : md(a) + ' – ' + md(b); }
  function finish() { var vals = options(true).map(function (x) { return x.value; }); for (var i = 0; i < vals.length; i++) { var c = colorOf(vals[i]); if (c) return { hex: c, name: vals[i].replace(/\b\w/g, function (m) { return m.toUpperCase(); }) }; } return null; }

  function initProof6(root) {
    if (root.__v) return; root.__v = 1;
    var chs = $$('.vnp6-ch__i', root), scs = $$('.vnp6-sc', root), stage = $('[data-vnp6-stage]', root);
    var hudL = $('[data-vnp6-hud-l]', root), hudR = $('[data-vnp6-hud-r]', root), cnt = $('[data-vnp6-count]', root);
    var mat = root.dataset.mat || 'micro', min = parseInt(root.dataset.min, 10) || 20, max = parseInt(root.dataset.max, 10) || 25, yrs = parseInt(root.dataset.years, 10) || 3;
    var cur = 0, timer = null, live = false, hold = false, coatT = null, DUR = 6500;
    var today = new Date(), first = addBD(today, 1), rA = addBD(today, min), rB = addBD(today, max);
    root.style.setProperty('--dur', DUR + 'ms');

    // calendar
    var cal = $('[data-vnp6-cal]', root);
    if (cal) {
      var off = (first.getDay() + 6) % 7, html = '', d = new Date(first), prevM = -1;
      for (var e = 0; e < off; e++) html += '<i class="x"></i>';
      for (var k = 1; k <= max; k++) {
        var cls = k >= min ? (k === max ? 'r e' : 'r') : '';
        html += '<i class="' + cls + '" style="--i:' + k + '"><span>' + (d.getMonth() !== prevM ? '<em>' + MON[d.getMonth()] + '</em>' : '') + d.getDate() + '</span></i>';
        prevM = d.getMonth();
        d = addBD(d, 1);
      }
      cal.innerHTML = html;
      $$('[data-vnp6-today]', root).forEach(function (x) { x.textContent = md(today); });
      $$('[data-vnp6-ready]', root).forEach(function (x) { x.textContent = rng(rA, rB); });
    }
    // warranty years
    var yb = $('[data-vnp6-years]', root);
    if (yb) {
      var y0 = rB.getFullYear(), h = '';
      for (var y = 0; y <= yrs; y++) h += '<span style="--i:' + y + '"><b>' + (y0 + y) + '</b></span>';
      yb.innerHTML = h;
      $$('[data-vnp6-wfrom]', root).forEach(function (x) { x.textContent = MON[rB.getMonth()] + ' ' + y0; });
      $$('[data-vnp6-wto]', root).forEach(function (x) { x.textContent = MON[rB.getMonth()] + ' ' + (y0 + yrs); });
    }
    var sealTxt = mat === 'micro' ? '9-layer seal' : (mat === 'stone' ? 'Sealed stone' : 'Sealed finish');
    $$('[data-vnp6-seal]', root).forEach(function (x) { x.textContent = sealTxt; });
    var steps = mat === 'micro' ? null : (mat === 'stone' ? ['Cut', 'Honed', 'Sealed'] : ['Sanded', 'Sealed', 'Finished']);
    var nCoat = steps ? steps.length : 9;
    $$('[data-vnp6-bars]', root).forEach(function (b) { var h2 = ''; for (var i = 0; i < nCoat; i++) h2 += '<i style="--i:' + i + '"></i>'; b.innerHTML = h2; });
    root.classList.add('is-' + mat);

    function paint() {
      var f = finish(), hex = (f && f.hex) || (mat === 'micro' ? '#E6E1D8' : mat === 'stone' ? '#D9C9AC' : '#BE9668');
      root.style.setProperty('--fin', hex); root.style.setProperty('--fin-d', shade(hex, -.12)); root.style.setProperty('--fin-l', shade(hex, .25));
      root.style.setProperty('--fin-ink', lum(hex) > .55 ? '#0F0E0C' : '#F4F1EB');
      root.__fname = f ? f.name : '';
    }
    function hudFor(i) {
      var sc = scs[i], v = sc && sc.dataset.vis, t = $('.vnp6-ch__t', chs[i]);
      hudL.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + scs.length).slice(-2) + ' — ' + (t ? t.textContent : '');
      var r = v === 'days' ? 'Live estimate' : v === 'shield' ? 'Frame warranty' : (root.__fname ? 'Finish · ' + root.__fname : 'Your finish');
      hudR.innerHTML = (v === 'trowel' || v === 'grain' || v === 'drop') ? '<i class="sw"></i>' + r : '<i class="dot"></i>' + r;
      cnt.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + scs.length).slice(-2);
    }
    function coat(sc) {
      clearTimeout(coatT);
      var slab = $('[data-vnp6-slab]', sc), bars = $$('[data-vnp6-bars] i', sc), kk = $('[data-vnp6-coat-k]', sc), ll = $('[data-vnp6-coat-l]', sc);
      if (!slab) return;
      var k = 0, gap = steps ? 1500 : 620;
      bars.forEach(function (b) { b.classList.remove('on'); });
      function step() {
        if (!sc.classList.contains('is-on')) return;
        k++; if (k > nCoat) { coatT = setTimeout(function () { k = 0; bars.forEach(function (b) { b.classList.remove('on'); }); step(); }, 1400); return; }
        slab.style.setProperty('--k', k);
        slab.style.setProperty('--tone', mat === 'micro' ? (k % 2 ? .03 : -.03) : 0);
        slab.style.setProperty('--basec', k > 1 ? 'var(--fin)' : 'var(--fin-d)');
        slab.classList.remove('sweep'); void slab.offsetWidth; slab.classList.add('sweep');
        if (bars[k - 1]) bars[k - 1].classList.add('on');
        kk.textContent = steps ? ('Step ' + ('0' + k).slice(-2) + ' / 0' + nCoat) : ('Coat ' + ('0' + k).slice(-2) + ' / 0' + nCoat);
        ll.textContent = steps ? steps[k - 1] : (k === nCoat ? 'Sealed' : k > 6 ? 'Protective seal' : 'Hand-applied microcement');
        coatT = setTimeout(step, gap);
      }
      step();
    }
    function count(sc) {
      $$('[data-count]', sc).forEach(function (b) {
        var to = parseInt(b.dataset.count, 10) || 0; if (!to || reduce) return; var t0 = null;
        (function f(ts) { if (!t0) t0 = ts; var q = clamp((ts - t0) / 1500, 0, 1); b.textContent = Math.max(1, Math.round(ease(q) * to)); if (q < 1) requestAnimationFrame(f); })(performance.now());
      });
    }
    function go(i, user) {
      i = (i + scs.length) % scs.length; cur = i; paint();
      chs.forEach(function (c, k) { var on = k === i; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', on); c.classList.remove('is-run'); });
      scs.forEach(function (sc, k) { var on = k === i; sc.classList.toggle('is-on', on); sc.classList.remove('is-play'); });
      void scs[i].offsetWidth; scs[i].classList.add('is-play');
      requestAnimationFrame(function () { chs[i].classList.add('is-run'); });
      var v = scs[i].dataset.vis; if (v === 'trowel' || v === 'grain') coat(scs[i]); else clearTimeout(coatT);
      count(scs[i]); hudFor(i);
      clearTimeout(timer); if (live && !hold && !reduce) timer = setTimeout(function () { go(cur + 1); }, DUR);
    }
    chs.forEach(function (c, k) { c.addEventListener('click', function () { go(k, true); }); c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(k, true); } }); });
    $('[data-vnp6-prev]', root).addEventListener('click', function () { go(cur - 1, true); });
    $('[data-vnp6-next]', root).addEventListener('click', function () { go(cur + 1, true); });
    stage.addEventListener('mouseenter', function () { if (!matchMedia('(hover:hover)').matches) return; hold = true; root.classList.add('is-hold'); clearTimeout(timer); });
    stage.addEventListener('mouseleave', function () { if (!hold) return; hold = false; root.classList.remove('is-hold'); go(cur); });
    var sx = null; stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), true); sx = null; }, { passive: true });
    onVariant(function () { paint(); hudFor(cur); });
    paint(); hudFor(0);
    inView(root, function (on) { live = on; if (on) go(cur); else { clearTimeout(timer); clearTimeout(coatT); } }, 0.3);
  }

  /* =================== MATERIAL · exploded layer drawing =================== */
  var C30 = Math.cos(Math.PI / 6), S30 = 0.5;
  function P(x, y, z) { return [(x - y) * C30, (x + y) * S30 - z]; }
  function outline(shape, L, D, n) {
    var pts = [], a = L / 2, b = D / 2, i, t;
    n = n || 64;
    if (shape === 'round' || shape === 'oval') { for (i = 0; i < n; i++) { t = i / n * Math.PI * 2; pts.push([a * Math.cos(t), b * Math.sin(t)]); } return pts; }
    if (shape === 'organic') { for (i = 0; i < n; i++) { t = i / n * Math.PI * 2; var w = 1 + 0.06 * Math.sin(3 * t + .6) + 0.04 * Math.cos(5 * t); var c = Math.cos(t), s = Math.sin(t); var e = 2 / 3.2; pts.push([a * w * Math.sign(c) * Math.pow(Math.abs(c), e), b * w * Math.sign(s) * Math.pow(Math.abs(s), e)]); } return pts; }
    // rounded rectangle
    var r = Math.min(a, b) * (shape === 'square' ? 0.12 : 0.16), q = 6;
    var cs = [[a - r, b - r, 0], [-a + r, b - r, Math.PI / 2], [-a + r, -b + r, Math.PI], [a - r, -b + r, Math.PI * 1.5]];
    cs.forEach(function (c) { for (var k = 0; k <= q; k++) { var th = c[2] + k / q * Math.PI / 2; pts.push([c[0] + r * Math.cos(th), c[1] + r * Math.sin(th)]); } });
    return pts;
  }
  function rectPts(x0, y0, x1, y1) { return [[x1, y1], [x0, y1], [x0, y0], [x1, y0]]; }
  function circlePts(cx, cy, r, n) { var p = []; n = n || 28; for (var i = 0; i < n; i++) { var t = i / n * Math.PI * 2; p.push([cx + r * Math.cos(t), cy + r * Math.sin(t)]); } return p; }
  function ptsStr(a) { return a.map(function (p) { return p[0].toFixed(2) + ',' + p[1].toFixed(2); }).join(' '); }
  function ccw(pts) { var s = 0; for (var i = 0; i < pts.length; i++) { var a = pts[i], b = pts[(i + 1) % pts.length]; s += (b[0] - a[0]) * (b[1] + a[1]); } return s < 0 ? pts : pts.slice().reverse(); }

  // prism = extruded outline [x,y] from z0 to z1
  function prism(pts, z0, z1, col, opt) { return { pts: ccw(pts), z0: z0, z1: z1, col: col, o: opt || {} }; }

  function drawPrism(g, pr, bounds) {
    var pts = pr.pts, o = pr.o, col = pr.col;
    var sides = [];
    for (var i = 0; i < pts.length; i++) {
      var a = pts[i], b = pts[(i + 1) % pts.length], dx = b[0] - a[0], dy = b[1] - a[1];
      var nx = dy, ny = -dx; // outward for CCW
      if (nx + ny <= 0.0001) continue;
      var len = Math.hypot(nx, ny) || 1, lx = nx / len, ly = ny / len;
      var f = -0.08 - 0.22 * (ly / (Math.abs(lx) + Math.abs(ly))); // y-facing darker, x-facing lighter
      sides.push({ q: [P(a[0], a[1], pr.z0), P(b[0], b[1], pr.z0), P(b[0], b[1], pr.z1), P(a[0], a[1], pr.z1)], f: f, d: (a[0] + a[1] + b[0] + b[1]) / 2 });
    }
    sides.sort(function (m, n) { return m.d - n.d; });
    var grp = el('g', { 'class': 'pr' + (o.cls ? ' ' + o.cls : ''), 'data-layer': o.layer || '' }, g);
    if (o.alpha != null) grp.setAttribute('opacity', o.alpha);
    sides.forEach(function (s) { el('polygon', { points: ptsStr(s.q), fill: shade(col, s.f), stroke: shade(col, s.f - .06), 'stroke-width': .25 }, grp); s.q.forEach(function (p) { bounds.push(p); }); });
    var top = pts.map(function (p) { return P(p[0], p[1], pr.z1); });
    top.forEach(function (p) { bounds.push(p); });
    var tp = el('polygon', { points: ptsStr(top), fill: o.topFill || col, stroke: o.edge || shade(col, -.18), 'stroke-width': .35 }, grp);
    if (o.grain || o.vein) {
      var id = 'vc' + Math.random().toString(36).slice(2, 8);
      var cp = el('clipPath', { id: id }, grp); el('polygon', { points: ptsStr(top) }, cp);
      var gg = el('g', { 'clip-path': 'url(#' + id + ')', fill: 'none', stroke: o.grain ? shade(col, -.22) : 'rgba(120,110,95,.45)', 'stroke-width': o.grain ? .45 : .6, 'stroke-linecap': 'round' }, grp);
      var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
      var x0 = Math.min.apply(0, xs), x1 = Math.max.apply(0, xs), y0 = Math.min.apply(0, ys), y1 = Math.max.apply(0, ys);
      if (o.grain) {
        for (var k = 0; k < 11; k++) { var yy = y0 + (y1 - y0) * (k + .5) / 11, d = '', amp = (y1 - y0) * .025; for (var s2 = 0; s2 <= 24; s2++) { var xx = x0 + (x1 - x0) * s2 / 24; var p2 = P(xx, yy + amp * Math.sin(s2 * .55 + k * 1.7), pr.z1); d += (s2 ? 'L' : 'M') + p2[0].toFixed(2) + ' ' + p2[1].toFixed(2); } el('path', { d: d }, gg); }
      } else {
        [[.15, .1, .9, .7], [.05, .6, .7, .95], [.45, .05, .95, .45]].forEach(function (v) { var d = '', n2 = 18; for (var s3 = 0; s3 <= n2; s3++) { var t = s3 / n2; var xx = x0 + (x1 - x0) * (v[0] + (v[2] - v[0]) * t), yy = y0 + (y1 - y0) * (v[1] + (v[3] - v[1]) * t) + (y1 - y0) * .04 * Math.sin(t * 9 + v[0] * 7); var p3 = P(xx, yy, pr.z1); d += (s3 ? 'L' : 'M') + p3[0].toFixed(2) + ' ' + p3[1].toFixed(2); } el('path', { d: d }, gg); });
      }
    }
    if (o.sheen) { el('polygon', { points: ptsStr(top), fill: 'url(#vnp5-sheen)', stroke: 'none' }, grp); }
    return { grp: grp, top: top };
  }

  // the piece: returns {body:[prisms], skin:{x0..} footprint pts, topZ, wall}
  function model(kind, shape, dims) {
    var m = { body: [], foot: null, topZ: 0, thick: 4, wall: null };
    var L, D, H, t;
    if (kind === 'nightstand') {
      L = 46; D = 36; H = 48; t = 2.4;
      m.foot = rectPts(-L / 2, -D / 2, L / 2, D / 2); m.topZ = H; m.thick = t;
      m.body.push({ pts: rectPts(-L / 2 + 1, -D / 2 + 1, L / 2 - 1, D / 2 - 1), z0: 9, z1: H - t, part: 'box' });
      [[-L / 2 + 3, -D / 2 + 3], [L / 2 - 6, -D / 2 + 3], [-L / 2 + 3, D / 2 - 6], [L / 2 - 6, D / 2 - 6]].forEach(function (c) { m.body.push({ pts: rectPts(c[0], c[1], c[0] + 3, c[1] + 3), z0: 0, z1: 9, part: 'leg' }); });
      m.drawer = { x0: -L / 2 + 4, x1: L / 2 - 4, y: D / 2 - 1, z0: 14, z1: H - t - 5 };
    } else if (kind === 'shelf') {
      L = 100; D = 22; H = 34; t = 3.2;
      m.foot = rectPts(-L / 2, 0, L / 2, D); m.topZ = H; m.thick = t;
      m.wall = { x0: -L / 2 - 14, x1: L / 2 + 14, z0: H - 30, z1: H + 30 };
    } else if (kind === 'side') {
      L = D = 50; H = 50; t = 3;
      if (dims && dims.L) { L = clamp(dims.L, 30, 70); D = clamp(dims.D || dims.L, 30, 70); }
      var sh = shape === 'rect' ? 'square' : shape; if (sh !== 'square' && sh !== 'rect') sh = shape === 'oval' ? 'oval' : 'round';
      m.foot = outline(sh, L, D); m.topZ = H; m.thick = t;
      m.body.push({ pts: circlePts(0, 0, Math.min(L, D) * .2), z0: 2, z1: H - t, part: 'leg' });
      m.body.push({ pts: circlePts(0, 0, Math.min(L, D) * .36), z0: 0, z1: 2.2, part: 'leg' });
    } else if (kind === 'coffee') {
      L = 110; D = 70; H = 35; t = 4;
      if (dims && dims.L) { L = clamp(dims.L, 60, 160); D = clamp(dims.D || dims.L, 40, 140); }
      if (shape === 'round' || shape === 'square') D = L;
      m.foot = outline(shape === 'rect' && Math.abs(L - D) < 5 ? 'square' : shape, L, D); m.topZ = H; m.thick = t;
      var pr2 = shape === 'round' || shape === 'organic' ? circlePts(0, 0, Math.min(L, D) * .26) : rectPts(-L * .28, -D * .22, L * .28, D * .22);
      m.body.push({ pts: pr2, z0: 0, z1: H - t, part: 'leg' });
    } else if (kind === 'console') {
      L = 150; D = 40; H = 80; t = 4;
      m.foot = rectPts(-L / 2, -D / 2, L / 2, D / 2); m.topZ = H; m.thick = t;
      m.body.push({ pts: rectPts(-L / 2 + 6, -D / 2 + 3, -L / 2 + 12, D / 2 - 3), z0: 0, z1: H - t, part: 'leg' });
      m.body.push({ pts: rectPts(L / 2 - 12, -D / 2 + 3, L / 2 - 6, D / 2 - 3), z0: 0, z1: H - t, part: 'leg' });
    } else {
      L = 200; D = 95; H = 75; t = 4.5;
      if (dims && dims.L) { L = clamp(dims.L, 120, 300); D = clamp(dims.D || 90, 70, 130); }
      if (shape === 'round') D = L = Math.min(L, 150);
      m.foot = outline(shape, L, D); m.topZ = H; m.thick = t;
      if (shape === 'round') m.body.push({ pts: circlePts(0, 0, L * .17), z0: 0, z1: H - t, part: 'leg' });
      else { var r = Math.min(D * .16, 15); [-1, 1].forEach(function (sx) { m.body.push({ pts: circlePts(sx * L * .27, 0, r), z0: 0, z1: H - t, part: 'leg' }); }); }
    }
    m.L = L; m.D = D; m.H = H;
    return m;
  }

  // skin layers per material profile, bottom → top. group: base | mid | top
  function skins(profile, fin, wood) {
    var core = '#6B655C';
    if (profile === 'micro') {
      var a = [{ g: 'base', t: 2.4, col: core }];
      for (var i = 0; i < 7; i++) a.push({ g: 'mid', t: .3, col: shade(fin, (i - 3) * .025) });
      a.push({ g: 'top', t: .35, col: shade(fin, .35), alpha: .55, sheen: 1 });
      return a;
    }
    if (profile === 'veneer') return [{ g: 'base', t: 2.8, col: core }, { g: 'mid', t: .8, col: fin, grain: 1 }, { g: 'top', t: .4, col: shade(fin, .4), alpha: .45, sheen: 1 }];
    if (profile === 'color') return [{ g: 'base', t: 2.6, col: wood, grain: 1 }, { g: 'mid', t: .6, col: fin }, { g: 'top', t: .35, col: shade(fin, .3), alpha: .5, sheen: 1 }];
    if (profile === 'stone') return [{ g: 'base', t: 2.8, col: shade(fin, -.04), vein: 1 }, { g: 'mid', t: .6, col: fin, vein: 1 }, { g: 'top', t: .35, col: shade(fin, .4), alpha: .45, sheen: 1 }];
    return [{ g: 'base', t: 2.6, col: fin, grain: 1 }, { g: 'mid', t: .6, col: shade(fin, .06), grain: 1 }, { g: 'top', t: .35, col: shade(fin, .4), alpha: .45, sheen: 1 }];
  }

  function pickProfile(base, vals) {
    var h = vals.join(' ');
    if (/travertine|marble|daino|stone/.test(h) && !/daino wood/.test(h)) return 'stone';
    if (/veneer/.test(h)) return 'veneer';
    var woody = /oak|walnut|wood|ash|cherry|teak|hazelnut|natural|\bdark\b|\bmedium\b|pine|fir/.test(h);
    if (base === 'micro') return woody ? 'veneer' : 'micro';
    if (base === 'stone') return woody ? 'solid' : (/off white|terracotta|beige|ivory|sand|gray|grey|earth|green/.test(h) ? 'micro' : 'stone');
    if (woody) return 'solid';
    if (/matte|green|black|white|terracotta|earth|brown|gray|grey|beige|lacquer|paint/.test(h)) return 'color';
    return 'solid';
  }

  function parseDims() {
    var o = options(false);
    for (var i = 0; i < o.length; i++) { var n = (o[i].value.match(/\d+(?:[.,]\d+)?/g) || []).map(parseFloat); if (n.length >= 2 && n[0] >= 20) return { L: n[0], D: n[1] }; if (n.length === 1 && n[0] >= 20 && /size|ø|cm/.test(o[i].name + o[i].value)) return { L: n[0], D: n[0] }; }
    return null;
  }

  function initMat(sec) {
    if (sec.__v) return; sec.__v = 1;
    var svg = $('[data-vnp5-svg]', sec), labels = $('[data-vnp5-labels]', sec), stage = $('[data-vnp5-stage]', sec);
    var meter = $('[data-vnp5-meter]', sec), finName = $('[data-vnp5-fin]', sec), sw = $('[data-vnp5-swatch]', sec);
    var kind = sec.dataset.kind, shape = sec.dataset.shape, base = sec.dataset.mat;
    var profiles = $$('.vnp5-prof', sec), factSets = $$('.vnp5-facts', sec);
    var state = { prof: sec.dataset.start, fin: '#E6E1D8', leg: null, name: '', dims: null, p: reduce ? 1 : 0, focus: null };
    var lbl = [];

    function profEl() { return profiles.filter(function (p) { return p.dataset.prof === state.prof; })[0] || profiles[0]; }
    function fallbackColor(pf) { return { micro: '#E6E1D8', veneer: '#9A6E45', solid: '#BE9668', color: '#55604A', stone: '#D9C9AC' }[pf] || '#E6E1D8'; }

    function apply() {
      var vals = options(true).map(function (x) { return x.value; });
      var pf = pickProfile(base, vals);
      if (!profiles.some(function (p) { return p.dataset.prof === pf; })) pf = profiles.some(function (p) { return p.dataset.prof === sec.dataset.start; }) ? sec.dataset.start : (profiles[0] && profiles[0].dataset.prof);
      var changed = pf !== state.prof; state.prof = pf;
      var fv = null; for (var i = 0; i < vals.length; i++) { if (colorOf(vals[i])) { fv = vals[i]; break; } }
      state.fin = colorOf(fv) || fallbackColor(pf); state.name = fv || '';
      var lv = legValue(); state.leg = colorOf(lv);
      state.dims = parseDims();
      profiles.forEach(function (p) { var on = p.dataset.prof === pf; p.hidden = !on; if (on) reveal(p); });
      factSets.forEach(function (f) { var on = f.dataset.prof === pf; f.hidden = !on; if (on) { reveal(f); f.classList.add('is-in'); inkTo(f); } });
      finName.textContent = state.name ? state.name.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '';
      sw.style.background = state.fin; sw.parentNode.hidden = !state.name;
      if (changed) { sec.classList.remove('is-swap'); void sec.offsetWidth; sec.classList.add('is-swap'); }
      buildLabels(); render();
    }

    function buildLabels() {
      var p = profEl(); labels.innerHTML = '';
      lbl = [['top', p.dataset.top], ['mid', p.dataset.mid], ['base', p.dataset.base]].filter(function (x) { return x[1]; }).map(function (x, k) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'vnp5-lbl'; b.dataset.g = x[0];
        b.innerHTML = '<span class="vnp5-lbl__n">0' + (k + 1) + '</span><span class="vnp5-lbl__t"></span>';
        b.querySelector('.vnp5-lbl__t').textContent = x[1];
        b.addEventListener('mouseenter', function () { setFocus(x[0], true); });
        b.addEventListener('mouseleave', function () { setFocus(null, true); });
        b.addEventListener('click', function () { setFocus(state.focus === x[0] ? null : x[0], true); });
        labels.appendChild(b); return b;
      });
    }
    var userFocus = 0;
    function setFocus(g, user) { if (user) userFocus = Date.now(); state.focus = g; sec.setAttribute('data-focus', g || ''); lbl.forEach(function (b) { b.classList.toggle('is-on', b.dataset.g === g); }); }

    function render() {
      var p = ease(clamp(state.p, 0, 1));
      var m = model(kind, shape, state.dims);
      var woodBase = '#BE9668';
      var layers = skins(state.prof, state.fin, woodBase);
      var legCol = state.leg || (kind === 'nightstand' || kind === 'shelf' ? state.fin : (state.prof === 'micro' || state.prof === 'stone' ? shade(state.fin, -.04) : state.fin));
      if (state.prof === 'color' && (kind === 'nightstand' || kind === 'shelf')) legCol = state.fin;
      var bodyCol = (state.prof === 'micro' || state.prof === 'veneer') ? legCol : (state.prof === 'color' ? state.fin : state.fin);
      var total = layers.reduce(function (a, l) { return a + l.t; }, 0), sc = m.thick / total;
      var GAP = Math.max(m.H * .16, 9), spread = (kind === 'shelf' ? 26 : Math.max(m.H * .62, 30));
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var defs = el('defs', {}, svg);
      var lg = el('linearGradient', { id: 'vnp5-sheen', x1: '0', y1: '0', x2: '1', y2: '1' }, defs);
      el('stop', { offset: '0', 'stop-color': '#fff', 'stop-opacity': '.55' }, lg); el('stop', { offset: '.45', 'stop-color': '#fff', 'stop-opacity': '.05' }, lg); el('stop', { offset: '1', 'stop-color': '#fff', 'stop-opacity': '.25' }, lg);
      var rg = el('radialGradient', { id: 'vnp5-shadow' }, defs); el('stop', { offset: '0', 'stop-color': '#000', 'stop-opacity': '.55' }, rg); el('stop', { offset: '1', 'stop-color': '#000', 'stop-opacity': '0' }, rg);
      var bounds = [], root = el('g', {}, svg);
      // floor shadow / wall
      if (m.wall) {
        var w = m.wall, wq = [P(w.x0, 0, w.z0), P(w.x1, 0, w.z0), P(w.x1, 0, w.z1), P(w.x0, 0, w.z1)];
        el('polygon', { points: ptsStr(wq), fill: 'rgba(244,241,235,.06)', stroke: 'rgba(244,241,235,.18)', 'stroke-width': .35, 'stroke-dasharray': '1.2 1.2' }, root); wq.forEach(function (q) { bounds.push(q); });
        // hidden bracket
        var bk = drawPrism(root, prism(rectPts(-m.L / 2 + 10, 0, m.L / 2 - 10, m.D - 6), m.topZ - m.thick - 1.6, m.topZ - m.thick, '#3B3833', { cls: 'is-leg' }), bounds);
      } else {
        var sp = m.foot.map(function (q) { return P(q[0] * 1.08, q[1] * 1.08, 0); });
        el('polygon', { points: ptsStr(sp), fill: 'rgba(0,0,0,.35)', filter: 'url(#vnp5-blur)' }, root);
        var fb = el('filter', { id: 'vnp5-blur', x: '-20%', y: '-20%', width: '140%', height: '140%' }, defs); el('feGaussianBlur', { stdDeviation: Math.max(m.L, m.D) * .025 }, fb);
      }
      // body parts (legs, boxes) — sorted by depth
      m.body.slice().sort(function (a, b) { var ca = a.pts.reduce(function (s, q) { return s + q[0] + q[1]; }, 0) / a.pts.length, cb = b.pts.reduce(function (s, q) { return s + q[0] + q[1]; }, 0) / b.pts.length; return ca - cb; }).forEach(function (b) {
        var col = b.part === 'box' ? bodyCol : legCol;
        var r = drawPrism(root, prism(b.pts, b.z0, b.z1, col, { cls: b.part === 'box' ? 'is-body' : 'is-leg', grain: b.part === 'box' && (state.prof === 'solid') }), bounds);
      });
      if (m.drawer) { var d = m.drawer, q = [P(d.x0, d.y, d.z0), P(d.x1, d.y, d.z0), P(d.x1, d.y, d.z1), P(d.x0, d.y, d.z1)]; el('polygon', { points: ptsStr(q), fill: 'none', stroke: shade(bodyCol, -.35), 'stroke-width': .4 }, root); var hc = P(0, d.y, d.z1 - 3); el('line', { x1: hc[0] - 4, y1: hc[1] + 2.3, x2: hc[0] + 4, y2: hc[1] - 2.3, stroke: shade(bodyCol, -.45), 'stroke-width': .9, 'stroke-linecap': 'round' }, root); }
      // skins — exploded upward
      var z = m.topZ - m.thick, anchors = { base: null, mid: null, top: null }, nMid = layers.filter(function (l) { return l.g === 'mid'; }).length, mi = 0;
      var lift = { base: 0, mid: spread * .45, top: spread };
      layers.forEach(function (l, idx) {
        var th = l.t * sc, off;
        if (l.g === 'base') off = 0; else if (l.g === 'mid') { off = lift.mid + (nMid > 1 ? (mi / (nMid - 1) - .5) * spread * .32 : 0); mi++; } else off = lift.top;
        var z0 = z + off * p, z1 = z0 + th;
        var r = drawPrism(root, prism(m.foot, z0, z1, l.col, { cls: 'is-skin g-' + l.g, layer: l.g, alpha: l.alpha, grain: l.grain, vein: l.vein, sheen: l.sheen }), bounds);
        // anchor = rightmost top point of the layer group (use last layer of group)
        var right = r.top.reduce(function (a, q) { return q[0] > a[0] ? q : a; }, [-1e9, 0]);
        anchors[l.g] = { x: right[0], y: right[1] + (z1 - z0) / 2 };
        z += th;
      });
      // stable view box (computed at full explode so nothing jumps)
      if (!render.vb || render.key !== kind + shape + (state.dims ? state.dims.L + 'x' + state.dims.D : '')) {
        var full = bounds.slice(), tz = m.topZ + spread + 2; m.foot.forEach(function (q) { full.push(P(q[0], q[1], tz)); });
        var xs = full.map(function (q) { return q[0]; }), ys = full.map(function (q) { return q[1]; });
        var x0 = Math.min.apply(0, xs), x1 = Math.max.apply(0, xs), y0 = Math.min.apply(0, ys), y1 = Math.max.apply(0, ys);
        var w2 = x1 - x0, h2 = y1 - y0, pad = Math.max(w2, h2) * .06, lab = w2 * .62;
        render.vb = [x0 - pad, y0 - pad, w2 + pad * 2 + lab, h2 + pad * 2]; render.key = kind + shape + (state.dims ? state.dims.L + 'x' + state.dims.D : '');
      }
      var vb = render.vb; svg.setAttribute('viewBox', vb.join(' ')); svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      // leader lines + label placement (html, % of viewBox)
      var lx = vb[0] + vb[2] - vb[2] * .3, ord = ['top', 'mid', 'base'];
      var box = svg.getBoundingClientRect(), art = svg.parentNode.getBoundingClientRect();
      var s2 = Math.min(box.width / vb[2], box.height / vb[3]) || 1, ox = (box.width - vb[2] * s2) / 2, oy = (box.height - vb[3] * s2) / 2;
      var bw = box.width || 1, bh = box.height || 1;
      var items = lbl.map(function (b) { var a = anchors[b.dataset.g]; if (!a) { b.hidden = true; return null; } b.hidden = false; return { b: b, a: a, y: oy + (a.y - vb[1]) * s2, h: b.offsetHeight || 24 }; }).filter(Boolean);
      items.sort(function (m, n) { return m.y - n.y; });
      var prev = -1e9; items.forEach(function (it) { var top = it.y - it.h / 2; if (top < prev + 6) it.y = prev + 6 + it.h / 2; prev = it.y + it.h / 2; });
      var over = items.length ? (items[items.length - 1].y + items[items.length - 1].h / 2) - bh : 0; if (over > 0) items.forEach(function (it) { it.y -= over; });
      items.forEach(function (it) {
        var ly = vb[1] + (it.y - oy) / s2, g = it.b.dataset.g;
        el('polyline', { points: [it.a.x + 1.5, it.a.y, lx - vb[2] * .05, ly, lx - vb[2] * .015, ly].join(' '), fill: 'none', 'class': 'vnp5-lead', 'data-g': g, 'stroke-width': .4 }, svg);
        el('circle', { cx: it.a.x + 1.5, cy: it.a.y, r: .9, 'class': 'vnp5-dot', 'data-g': g }, svg);
        it.b.style.left = ((ox + (lx - vb[0]) * s2) / bw * 100) + '%';
        it.b.style.top = (it.y / bh * 100) + '%';
      });
      sec.style.setProperty('--p', p.toFixed(3));
      if (meter) meter.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      sec.classList.toggle('is-open', p > .92);
    }

    function inkTo(f) { var on = $('.vnp5-facts__tabs .is-on', f), ink = $('.vnp5-facts__ink', f); if (on && ink) { ink.style.width = on.offsetWidth + 'px'; ink.style.transform = 'translateX(' + on.offsetLeft + 'px)'; } }
    factSets.forEach(function (f) {
      $$('.vnp5-facts__tabs button', f).forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.dataset.t; $$('.vnp5-facts__tabs button', f).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          $$('.vnp5-facts__col', f).forEach(function (c) { c.classList.toggle('is-on', c.dataset.p === t); }); inkTo(f);
        });
      });
      window.addEventListener('resize', function () { inkTo(f); });
    });

    // scroll-driven explode
    var raf = 0, live = false;
    function onScroll() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; var r = stage.getBoundingClientRect(), vh = window.innerHeight; var t = (vh * .92 - r.top) / (vh * .92 - vh * .18 + r.height * .1); var np = clamp(t, 0, 1); if (Math.abs(np - state.p) > .002) { state.p = np; render(); } }); }
    if (!reduce) { window.addEventListener('scroll', onScroll, { passive: true }); }
    window.addEventListener('resize', function () { render(); });
    // guided focus once open
    var cyc = 0, timer;
    function tick() { clearTimeout(timer); timer = setTimeout(function () { if (live && sec.classList.contains('is-open') && Date.now() - userFocus > 6000) { var g = ['top', 'mid', 'base'][cyc++ % 3]; setFocus(g, false); } tick(); }, 2200); }
    inView(sec, function (on) { live = on; if (on) { onScroll(); tick(); } else { clearTimeout(timer); setFocus(null, false); } }, 0.2);
    apply(); onVariant(apply);
  }

  /* =================== SAMPLE KIT =================== */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), parts = v.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}'; return fmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
  }
  function initSamples(root) {
    if (root.__v) return; root.__v = 1;
    var btn = $('[data-vnp5-add]', root), total = $('[data-vnp5-total]', root), cnt = $('[data-vnp5-count]', root), unit = $('[data-vnp5-unit]', root), stack = $('[data-vnp5-stack]', root), err = $('[data-vnp5-err]', root);
    var boxes = $$('input[type="checkbox"]', root), touched = false, fmt = root.dataset.moneyFormat;
    function sum() {
      var c = boxes.filter(function (b) { return b.checked; }), cents = c.reduce(function (t, b) { return t + (parseInt(b.dataset.price, 10) || 0); }, 0);
      total.textContent = c.length ? money(cents, fmt) : '—'; cnt.textContent = c.length; unit.textContent = c.length === 1 ? unit.dataset.one : unit.dataset.many;
      btn.disabled = !c.length; btn.querySelector('span').textContent = c.length ? btn.dataset.label : btn.dataset.empty; btn.classList.remove('is-done');
      stack.innerHTML = '';
      c.slice(0, 6).forEach(function (b, i) { var s = document.createElement('i'); if (b.dataset.img) s.style.backgroundImage = 'url(' + b.dataset.img + ')'; else { s.className = 'is-set'; s.textContent = '+'; } s.style.zIndex = 10 - i; stack.appendChild(s); });
      if (c.length > 6) { var more = document.createElement('i'); more.className = 'is-more'; more.textContent = '+' + (c.length - 6); stack.appendChild(more); }
      root.classList.toggle('has-sel', c.length > 0);
    }
    boxes.forEach(function (b) { b.addEventListener('change', function () { touched = true; var l = b.closest('label'); if (l) { l.classList.remove('is-pop'); void l.offsetWidth; l.classList.add('is-pop'); } sum(); }); });
    function match() {
      if (touched) return; var sel = options(false).map(function (x) { return x.value; });
      $$('.vnp5-sw', root).forEach(function (sw) { var t = $('.vnp5-sw__t', sw).textContent.trim().toLowerCase(), inp = $('input', sw); var m = sel.some(function (v) { return v === t || v.indexOf(t) > -1 || (v.length > 3 && t.indexOf(v) === 0); }); sw.classList.toggle('is-match', m); if (!inp.disabled) inp.checked = m; });
      sum();
    }
    onVariant(match);
    btn.addEventListener('click', function () {
      var items = boxes.filter(function (b) { return b.checked; }).map(function (b) { return { id: parseInt(b.value, 10), quantity: 1 }; });
      if (!items.length) return;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      btn.disabled = true; err.hidden = true; btn.classList.add('is-busy');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          btn.classList.remove('is-busy');
          if (j.status && j.description) { err.textContent = j.description; err.hidden = false; btn.disabled = false; return; }
          btn.querySelector('span').textContent = btn.dataset.added; btn.classList.add('is-done'); btn.disabled = false;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vaen-samples', cartData: j });
          if (cart && cart.renderContents && j.sections) { if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.renderContents(j); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { btn.classList.remove('is-busy'); err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; btn.disabled = false; });
    });
    match();
  }

  function init() {
    $$('[data-vnp6-proof]').forEach(initProof6);
    $$('[data-vnp7-more]').forEach(initMore);
    $$('[data-vnp8-faq]').forEach(initFaq);
    initGallery(); optionDots();
    $$('[data-vnp10-trade]').forEach(initTrade);
    $$('[data-vnp5-mat]').forEach(initMat);
    $$('[data-vnp5-samples]').forEach(initSamples);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
